// Theme: void-petal
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'void-petal',
  name: 'VOID PETAL',
  tagline: 'VOID PETAL',
  description: 'Petala clara sobre base escura com contraste suave.',
  category: 'fantasy-realms',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#100818', '#1A1028', '#EDE9FE', '#FAF5FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-void-petal'
  },
  colorVars: {
    '--accent': '#EDE9FE',
    '--accent-foreground': '#100818',
    '--background': '#100818',
    '--border': '#6A3A8A',
    '--card': '#1A1028',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FAF5FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#100818',
    '--foreground': '#FAF5FF',
    '--hold-fill': '#EDE9FE',
    '--input': '#6A3A8A',
    '--modal-bg': '#100818',
    '--modal-border': '#6A3A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#6A3A8A',
    '--muted-foreground': '#FAF5FF',
    '--nav-active': '#EDE9FE',
    '--nav-bg': '#1A1028',
    '--popover': '#1A1028',
    '--popover-foreground': '#FAF5FF',
    '--primary': '#EDE9FE',
    '--primary-foreground': '#100818',
    '--ring': '#EDE9FE',
    '--secondary': '#6A3A8A',
    '--secondary-foreground': '#FAF5FF',
    '--streak': '#EDE9FE',
    '--success': '#22c55e',
    '--success-foreground': '#100818',
    '--xp': '#EDE9FE',
    '--xp-bg': '#1A1028'
  },
  resolvedVars: {
    '--accent': '#EDE9FE',
    '--accent-foreground': '#100818',
    '--accent-foreground-hsl': '270 50% 6%',
    '--accent-foreground-oklch': 'from #100818 l c h',
    '--accent-hsl': '251 91% 95%',
    '--accent-oklch': 'from #EDE9FE l c h',
    '--background': '#100818',
    '--background-hsl': '270 50% 6%',
    '--background-oklch': 'from #100818 l c h',
    '--border': '#6A3A8A',
    '--border-hsl': '276 41% 38%',
    '--border-oklch': 'from #6A3A8A l c h',
    '--border-w': '1px',
    '--card': '#1A1028',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FAF5FF',
    '--card-foreground-hsl': '270 100% 98%',
    '--card-foreground-oklch': 'from #FAF5FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '265 43% 11%',
    '--card-oklch': 'from #1A1028 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#100818',
    '--destructive-foreground-hsl': '270 50% 6%',
    '--destructive-foreground-oklch': 'from #100818 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FAF5FF',
    '--foreground-hsl': '270 100% 98%',
    '--foreground-oklch': 'from #FAF5FF l c h',
    '--hold-fill': '#EDE9FE',
    '--hold-fill-hsl': '251 91% 95%',
    '--hold-fill-oklch': 'from #EDE9FE l c h',
    '--input': '#6A3A8A',
    '--input-hsl': '276 41% 38%',
    '--input-oklch': 'from #6A3A8A l c h',
    '--modal-bg': '#100818',
    '--modal-bg-hsl': '270 50% 6%',
    '--modal-bg-oklch': 'from #100818 l c h',
    '--modal-border': '#6A3A8A',
    '--modal-border-hsl': '276 41% 38%',
    '--modal-border-oklch': 'from #6A3A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#6A3A8A',
    '--muted-foreground': '#FAF5FF',
    '--muted-foreground-hsl': '270 100% 98%',
    '--muted-foreground-oklch': 'from #FAF5FF l c h',
    '--muted-hsl': '276 41% 38%',
    '--muted-oklch': 'from #6A3A8A l c h',
    '--nav-active': '#EDE9FE',
    '--nav-active-hsl': '251 91% 95%',
    '--nav-active-oklch': 'from #EDE9FE l c h',
    '--nav-bg': '#1A1028',
    '--nav-bg-hsl': '265 43% 11%',
    '--nav-bg-oklch': 'from #1A1028 l c h',
    '--popover': '#1A1028',
    '--popover-foreground': '#FAF5FF',
    '--popover-foreground-hsl': '270 100% 98%',
    '--popover-foreground-oklch': 'from #FAF5FF l c h',
    '--popover-hsl': '265 43% 11%',
    '--popover-oklch': 'from #1A1028 l c h',
    '--primary': '#EDE9FE',
    '--primary-foreground': '#100818',
    '--primary-foreground-hsl': '270 50% 6%',
    '--primary-foreground-oklch': 'from #100818 l c h',
    '--primary-hsl': '251 91% 95%',
    '--primary-oklch': 'from #EDE9FE l c h',
    '--radius': '10px',
    '--ring': '#EDE9FE',
    '--ring-hsl': '251 91% 95%',
    '--ring-oklch': 'from #EDE9FE l c h',
    '--secondary': '#6A3A8A',
    '--secondary-foreground': '#FAF5FF',
    '--secondary-foreground-hsl': '270 100% 98%',
    '--secondary-foreground-oklch': 'from #FAF5FF l c h',
    '--secondary-hsl': '276 41% 38%',
    '--secondary-oklch': 'from #6A3A8A l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#EDE9FE',
    '--streak-hsl': '251 91% 95%',
    '--streak-oklch': 'from #EDE9FE l c h',
    '--success': '#22c55e',
    '--success-foreground': '#100818',
    '--success-foreground-hsl': '270 50% 6%',
    '--success-foreground-oklch': 'from #100818 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(251 91% 95% / 0.15)',
    '--xp': '#EDE9FE',
    '--xp-bg': '#1A1028',
    '--xp-bg-hsl': '265 43% 11%',
    '--xp-bg-oklch': 'from #1A1028 l c h',
    '--xp-hsl': '251 91% 95%',
    '--xp-oklch': 'from #EDE9FE l c h'
  }
}
